<template>
  <div class="CollaborationCase" v-if="CaseData.infoId">
    <div class="i_img">
      <img :src="CaseData.infoImage" alt="">
    </div>
    <div class="i_main">
      <div class="m_title textslh">
        {{ CaseData.infoName }}
      </div>
      <div class="m_desc" v-html="CaseData.infoContent ">
      </div>
      <div class="m_row">
        <div class="btn_black" @click="ToBlack">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollaborationCase',
  data () {
    return {
      CaseData: {}
    }
  },
  mounted () {
    let data = sessionStorage.jsonData ? JSON.parse(sessionStorage.jsonData) : {}
    this.$set(this, 'CaseData', data)
    // console.log('查看合作伙伴详情22222222222', data)
  },
  methods: {
    ToBlack () {
      this.$emit('ToBlack')
    }
  },
}
</script>

<style lang="scss" scoped>
.CollaborationCase {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: inherit;
  .i_img {
    flex-shrink: 0;
    width: 292px;
    height: 170px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .i_main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 20px;
    .m_title {
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      padding-bottom: 20px;
    }
    .m_desc {
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      text-align: justify;
      line-height: 24px;
      text-indent: 32px;
    }
    .m_row {
      padding-top: 40px;
      display: flex;
      justify-content: flex-end;
    }
    .btn_black {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      width: 150px;
      height: 36px;
      background: #406cdd;
      border-radius: 8px;
    }
  }
}
</style>